import { GzGeneralSecurityTelemetryWebComponent } from './component/GzGeneralSecurityTelemetryWebComponent';

export { GzGeneralSecurityTelemetryWebComponent };
